import { DIAS_SEMANA } from "../../utils/cobrancaLote";

// Frequência de cobrança do cliente (Dani, 19/09): diária (padrão), semanal num dia da semana ou quinzenal em dois dias do mês.
const DIAS_DO_MES = Array.from({ length: 31 }, (_, i) => i + 1);
const OPCOES = [
    { tipo: "diaria", rotulo: "Diária" },
    { tipo: "semanal", rotulo: "Semanal" },
    { tipo: "quinzenal", rotulo: "Quinzenal" },
];

export default function CampoCobranca({ valor, onChange }) {
    const f = valor || { tipo: "diaria" };
    const escolher = (tipo) => {
        if (tipo === f.tipo) return;
        if (tipo === "semanal") onChange({ tipo, dia: 5 });
        else if (tipo === "quinzenal") onChange({ tipo, dias: [15, 30] });
        else onChange({ tipo: "diaria" });
    };
    const trocarDiaQuinzena = (i, v) => {
        const dias = [...f.dias];
        dias[i] = Number(v);
        onChange({ ...f, dias });
    };

    return (
        <div>
            <div style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 8 }}>
                {OPCOES.map((o) => (
                    <button key={o.tipo} type="button" aria-pressed={f.tipo === o.tipo}
                        style={{ whiteSpace: "nowrap", minHeight: 44, padding: "8px 4px", fontSize: "0.92rem", fontWeight: 700 }}
                        className={`btn ${f.tipo === o.tipo ? "btn-he" : "btn-outline-he"}`} onClick={() => escolher(o.tipo)}>
                        {o.rotulo}
                    </button>
                ))}
            </div>
            {f.tipo === "semanal" &&
                <div style={{ display: "flex", alignItems: "center", gap: 8, marginTop: 10, flexWrap: "wrap" }}>
                    <span style={{ color: "#9aa5b5", fontSize: "0.88rem" }}>Cobrar toda</span>
                    <select className="form-select" style={{ width: "auto", minWidth: 150 }} value={f.dia}
                        onChange={(e) => onChange({ ...f, dia: Number(e.target.value) })}>
                        {DIAS_SEMANA.map((d, i) => i > 0 && <option key={d} value={i}>{d}</option>)}
                    </select>
                </div>
            }
            {f.tipo === "quinzenal" &&
                <div style={{ display: "flex", alignItems: "center", gap: 8, marginTop: 10, flexWrap: "wrap" }}>
                    <span style={{ color: "#9aa5b5", fontSize: "0.88rem" }}>Cobrar nos dias</span>
                    <select className="form-select" style={{ width: "auto", minWidth: 80 }} value={f.dias[0]} onChange={(e) => trocarDiaQuinzena(0, e.target.value)}>
                        {DIAS_DO_MES.map((d) => <option key={d} value={d}>{d}</option>)}
                    </select>
                    <span style={{ color: "#9aa5b5", fontSize: "0.88rem" }}>e</span>
                    <select className="form-select" style={{ width: "auto", minWidth: 80 }} value={f.dias[1] ?? f.dias[0]} onChange={(e) => trocarDiaQuinzena(1, e.target.value)}>
                        {DIAS_DO_MES.map((d) => <option key={d} value={d}>{d}</option>)}
                    </select>
                </div>
            }
            <small style={{ display: "block", color: "#9aa5b5", marginTop: 8, lineHeight: 1.45 }}>
                {f.tipo === "diaria"
                    ? "O robô cobra todo dia, de segunda a sábado."
                    : "No dia combinado o robô cobra tudo o que venceu até ali, num PIX só. Caiu no domingo? Cobra na segunda. Dia 30/31 em mês curto vira o último dia."}
            </small>
        </div>
    );
}
